import $ from 'jquery';

// Shopping cart js YW
window.responsiveCart = function (action) {
          if (action == 'show') {
            $('.abc-header-responsive-cart__backdrop').css({
              'pointer-events': 'initial',
            });
          }

          if (action == 'hide') {
            $('.abc-header-responsive-cart__backdrop').css({
              'pointer-events': 'none',
            });
          }

          $('#abc-footer-responsive-cart').stop().animate({
            width: action,
          }, {
            duration: 500,
            specialEasing: {
              width: 'easeOutCubic',
            },
            start: function () {
              $('.abc-footer-responsive-cart__backdrop').stop().animate({
                opacity: action,
              }, {
                duration: 500,
                specialEasing: {
                  opacity: 'easeOutCubic',
                },
              });
            },
          });
        }// end Shopping cart js YW
let responsiveCart = window.responsiveCart;
export {responsiveCart};

